import { useEffect, useState } from "react";
import LiveWebScanner from "@/components/barcode/LiveWebScanner";
import PhotoCapture from "@/components/barcode/PhotoCapture";
import { primeBeep } from "@/components/barcode/scanUtils";

// Live camera scanner on every platform (web, iOS & Android apps). Photo capture only if the camera is unavailable.
export default function BarcodeScanner({ onDetected, onDone, onClose }) {
  const [fallback, setFallback] = useState(false);
  useEffect(() => { primeBeep(); }, []);
  if (fallback) return <PhotoCapture onDetected={onDetected} onClose={onClose} />;
  return <LiveWebScanner onDone={onDone} onClose={onClose} onUnavailable={() => setFallback(true)} />;
}
